import React, { useState } from "react";
import "./ContactUs.css";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const NAME_REGEX =
  /^[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ]+(?:[-\s][a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ]+)*$/;
const EMAIL_REGEX = /\S+@\S+\.\S+/;

const ContactUs = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [subject, setSubject] = useState("");
  const [email, setEmail] = useState("");
  const [content, setContent] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [isSent, setIsSent] = useState(false);

  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    subject: "",
    email: "",
  });

  const validateFields = async () => {
    let isValid = true;
    const newErrors = {};

    if (!firstName.trim()) {
      newErrors.firstName = "Imię jest wymagane";
      isValid = false;
    } else if (!NAME_REGEX.test(firstName)) {
      newErrors.firstName =
        "Imię nie może zawierać cyfr ani znaków specjalnych";
      isValid = false;
    }

    if (!lastName.trim()) {
      newErrors.lastName = "Nazwisko jest wymagane";
      isValid = false;
    } else if (!NAME_REGEX.test(lastName)) {
      newErrors.lastName =
        "Nazwisko nie może zawierać cyfr ani znaków specjalnych";
      isValid = false;
    }

    if (!email.trim()) {
      newErrors.email = "Adres email jest wymagany";
      isValid = false;
    } else if (!EMAIL_REGEX.test(email)) {
      newErrors.email = "Podaj poprawny adres email";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!(await validateFields())) {
      return;
    }

    const messageData = { firstName, lastName, subject, email, content };

    try {
      const response = await fetch(
        `${API_BASE_URL}/api/emailMessage/sendMessage`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(messageData),
        },
      );

      if (response.ok) {
        setFirstName("");
        setLastName("");
        setSubject("");
        setEmail("");
        setContent("");
        setErrors({});
        setIsSent(true);

      } else {
        console.error("Błąd przy wysyłaniu wiadomości");
      }
    } catch (error) {
      console.error("Wystąpił błąd:", error);
    } finally {
      setIsSending(false);
      setTimeout(() => setIsSent(false), 3000);
    }
  };

  return (
    <section id="contact" className="section-contact" onSubmit={handleSubmit}>
      <div className="container" style={{ marginTop: 70, marginBottom: 50 }}>
        <div className="section-title text-center mb-3">
          <h2>Skontaktuj się z nami</h2>
          <p className="form-text">Masz więcej pytań? Skontaktuj się z nami poprzez formularz.</p>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="mb-5 p-3 rounded form-container">
              <form className="row form-row">
                <div className="col-md-6">
                  <div className="form-group mb-2 card-label">
                    <label>Twoje Imię</label>
                    <input
                      className="form-control"
                      type="text"
                      name="firstName"
                      placeholder="Twoje Imię"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group mb-2 card-label">
                    <label>Twoje Nazwisko</label>
                    <input
                      className="form-control"
                      type="text"
                      name="lastName"
                      placeholder="Twoje Nazwisko"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group mb-2 card-label">
                    <label>Temat wiadomości</label>
                    <input
                      className="form-control"
                      type="text"
                      name="subject"
                      placeholder="Temat wiadomości"
                      value={subject}
                      onChange={(e) => setSubject(e.target.value)}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group mb-2 card-label">
                    <label>Email</label>
                    <input
                      className="form-control"
                      type="email"
                      name="email"
                      placeholder="Twój email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="form-group mb-2 card-label">
                    <label>Twoja wiadomość</label>
                    <textarea
                      className="form-control"
                      name="content"
                      cols="30"
                      rows="10"
                      placeholder="Twoja wiadomość"
                      value={content}
                      onChange={(e) => setContent(e.target.value)}
                    />
                  </div>
                </div>
                {errors.firstName && (
                  <small className="error-text">{errors.firstName}</small>
                )}
                {errors.lastName && (
                  <small className="error-text">{errors.lastName}</small>
                )}
                {errors.subject && (
                  <small className="error-text">{errors.subject}</small>
                )}
                {errors.email && (
                  <small className="error-text">{errors.email}</small>
                )}
                <div className="text-center">
                  <button
                    type="submit"
                    className={`btn-submit-email ${isSending ? "sending" : ""} ${isSent ? "sent" : ""}`}
                    disabled={isSending || isSent}
                  >
                    {isSending ? "Wysyłanie..." : isSent ? "Wysłano!" : "Wyślij"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
